import type { FloorPlanName } from '@/app/floor-plans/types';
import {
  FLOOR_PLANS_DETAILS,
  type FloorPlanDetails,
} from '@/app/floor-plans/ui/FloorPlansList/consts';

export const FLOOR_PLANS_TITLE = 'Floor Plans';

export interface FeaturedFloorPlan {
  name: FloorPlanName;
  details: FloorPlanDetails;
  slug: string;
}

const FEATURED_NAMES: FloorPlanName[] = [
  'Willow',
  'Redbud',
  'Kingston',
  'Birch',
];

export const FEATURED_FLOOR_PLANS: FeaturedFloorPlan[] = FEATURED_NAMES.map(
  name => ({
    name,
    details: FLOOR_PLANS_DETAILS[name],
    slug: name.toLowerCase().replace(/\s+/g, '-'),
  }),
);
